import { doc, updateDoc } from "firebase/firestore";
import TokenSalePhaseType from "../TokenSalePhaseType";
import FirebaseConfig from "../../../config/firebase";

export default async function (phase: TokenSalePhaseType) {
  await updateDoc(doc(FirebaseConfig.db, "tokenSalePhases", phase.uid!), {
    ...phase,
  });
}
